export const DOMAIN = 'dsarReporting';
